@if (updateManager.showBanner()) {
  <div class="update-banner fixed inset-x-0 bottom-0 z-[1100] px-3 pb-[max(env(safe-area-inset-bottom),0.75rem)] sm:px-4 sm:pb-4">
    <div
      class="update-banner__card mx-auto flex w-full max-w-2xl flex-col gap-3 rounded-xl border border-[#0054a6]/20 bg-white/95 p-4 shadow-lg backdrop-blur sm:flex-row sm:items-center sm:justify-between"
      aria-live="polite"
      role="status"
    >
      <div class="text-sm sm:text-base text-[#0b2d4f]">
        <span class="block font-semibold text-[#0054a6]">
          @if (updateManager.status() === 'failed' || updateManager.status() === 'unrecoverable') {
            {{ title() }}
          } @else if (updateManager.latestVersionLabel(); as latestVersion) {
            Nueva versión disponible: {{ latestVersion }}.
          } @else {
            Nueva versión disponible.
          }
        </span>
        <span>{{ description() }}</span>
      </div>
      <div class="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-end">
        <app-ui-button
          class="w-full sm:w-auto"
          variant="primary"
          [disabled]="!canApply()"
          (buttonClick)="applyUpdate()"
        >
          {{ primaryLabel() }}
        </app-ui-button>
        <app-ui-button
          class="w-full sm:w-auto"
          variant="secondary"
          (buttonClick)="dismiss()"
        >
          Más tarde
        </app-ui-button>
      </div>
    </div>
  </div>
}
